import { render, staticRenderFns } from "./InventoryModuleMenu.vue?vue&type=template&id=d0998e2c"
import script from "./InventoryModuleMenu.vue?vue&type=script&lang=js"
export * from "./InventoryModuleMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports